/**
 * @GENERATED from Figma node 6697:34308
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MondayDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#F62B54"
      d="M4.456 17.875a2.46 2.46 0 0 1-2.149-1.25 2.4 2.4 0 0 1 .068-2.463L6.8 7.192a2.47 2.47 0 0 1 4.298.116c.413.783.361 1.724-.133 2.459l-4.422 6.97a2.47 2.47 0 0 1-2.087 1.138"
    />
    <path
      fill="#FC0"
      d="M12.264 17.875a2.46 2.46 0 0 1-2.145-1.248 2.39 2.39 0 0 1 .068-2.455l4.416-6.955A2.47 2.47 0 0 1 16.79 6c.9.02 1.715.525 2.128 1.315.41.79.35 1.737-.16 2.47l-4.415 6.954a2.47 2.47 0 0 1-2.079 1.135"
    />
    <path
      fill="#00CA72"
      d="M19.656 18.188a2.344 2.344 0 1 0 0-4.688 2.344 2.344 0 0 0 0 4.688"
    />
  </svg>
);
const ForwardRef = React.forwardRef(MondayDark);
export { ForwardRef as MondayDark };
